/*
 * Tabs script
 */
class ME_Submenu {
    constructor() {
        this.initState();
    }

    initState() {
        this.submenus = $('.submenu');
        if (this.submenus.length) {
            this.initSubmenusEvents();
        }
    }

    initSubmenusEvents() {
        $('.submenu ul.menu').each(function () {
            var active = $(this).children('li.active').length > 0 ? $(this).children('li.active a').html() : $(this).children('li').eq(0).find('a').html();
            $(this).before("<div class='current-tab'>" + active + "</div>");
        });

        $('.submenu ul.menu li').click(function () {
            $(this).parent('ul.menu').prev('.current-tab').html($(this).find('a').html());
            $(this).parent('ul.menu').removeClass('active');
        });

        $('.submenu .current-tab').click(function () {
            $(this).next('ul.menu').toggleClass('active');
        });
    }
}
